// extracted by mini-css-extract-plugin
module.exports = {"container":"libs_container__3pym9","imgBlock":"libs_imgBlock__3pNVe","img":"libs_img__1OG0T","title":"libs_title__15N-c","desc":"libs_desc__2tTTO"};